import React from 'react';
import { Button, Group, Modal, Text } from '@mantine/core';

const ConfirmModal = ({ opened, onClose, isAutoScan, onConfirm }) => {
  const enableDisableLabelText = isAutoScan ? 'Disable' : 'Enable';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="sm"
      title={isAutoScan ? 'Disable Auto Scan' : 'Enable Auto Scan'}
    >
      <Text size="sm" c="dimmed" mb="md">
        {`Are you sure you want to ${enableDisableLabelText.toLowerCase()} Auto Scan?`}
      </Text>
      <Group justify="flex-end">
        <Button variant="default" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="sm"
          color={isAutoScan ? 'red' : 'brand'}
          variant={isAutoScan ? 'outline' : 'filled'}
          onClick={onConfirm}
        >
          {enableDisableLabelText}
        </Button>
      </Group>
    </Modal>
  );
};

export default ConfirmModal;
